export default function ImageConvertionDefault(ImageUrl ,  width , height) {
    if (ImageUrl == null){
        ImageUrl = "https://nonprod-media.webdunia.com/public_html/app-logo/te-logo.png";

    }
    //return ImageUrl;
    if(ImageUrl.includes('http:')){
        ImageUrl =  ImageUrl.replace(/^http:\/\//i, 'https://');
    }
    if(ImageUrl.includes('https://media.webdunia.com')){
        ImageUrl =  ImageUrl.replace('https://media.webdunia.com', 'https://nonprod-media.webdunia.com/public_html');
    }
width = (typeof width == "undefined") ? ""  : width ;
height = (typeof height == "undefined") ? ""  : height ;
//outType = (outType =! "undefined") ? outType  : "webp" ;      

// var convertionUrl = "https://wd-image.webdunia.com/image-conversion/process-aws.php?url="+ImageUrl+"&w="+width+"&h="+height+"&outtype=webp";
//var convertionUrl = "https://wdimage.webdunia.com/image-conversion/process?url="+ImageUrl+"&outtype=webp";
 if(!height){height=''}
if(!width){width='720'}

    const processedUrl = ImageUrl.replace('https://nonprod-media.webdunia.com/public_html', '');
    return `https://wd-image.webdunia.com/processimg/${width}x${height}/webp${processedUrl}`;
// return processedUrl;
}
export  function ImageConvertionDefault1(ImageUrl) { 
    if(ImageUrl.includes('http:')){
        ImageUrl =  ImageUrl.replace(/^http:\/\//i, 'https://');
    }
var convertionUrl = "https://wdimage.webdunia.com/image-conversion/process?url="+ImageUrl+"&outtype=webp";
return convertionUrl;
} 
